<template>
  <div class="submit-btn-container">
    <button
      class="btn"
      :disabled="disabled"
      @click="$emit('submit')"
    >{{ $t("QUESTION_FORM.SUBMIT") }}</button>
  </div>
</template>

<script>
export default {
  name: 'question-form-submit-button',
  props: {
    disabled: Boolean
  }
};
</script>

<style lang="scss" scoped>
.submit-btn-container {
  text-align: center;
}
.btn {
  padding: 10px 30px;
  margin-bottom: 20px;
  text-transform: uppercase;
  background-color: #6a7584;
  color: #fff;
  font-size: 20px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  &:disabled {
    background-color: #e2e5ea;
  }
  &:hover:enabled {
    background-color: #3f536e;
  }
}
</style>
